import type { TestType } from '@prisma/client';

export const mobile = {
  // Even though it says "Mozilla" and "Safari", this is actually a mobile user agent got from an iphone 14 using Google Chrome
  userAgent:
    'Mozilla/5.0 (iPhone; CPU iPhone OS 17_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/133.0.6943.33 Mobile/15E148 Safari/604.1',
  // iphone 13 viewport
  viewport: {
    width: 390,
    height: 844,
  },
} as const;

export const desktop = {
  // Default 16:9 recorder viewport
  viewport: {
    width: 1920,
    height: 1080,
  },
} as const;

export function getDeviceViewport(testType?: TestType) {
  return (
    testType === 'WEB' ? desktop.viewport
    : testType === 'WEB_MOBILE' ? mobile.viewport
    : testType === 'MOBILE_APP' ? mobile.viewport
    : desktop.viewport
  );
}
